import React from 'react';
import t from "../../../../../helpers/t";
import {moment} from "../../../../../../../vendor";
import {Biscuit} from "../../../../../../utils";
import {rbac} from "../../../index";

const StaffWebView = (props) => {
    const {user, index, deleteUserPending, onDeleteUser, currentUrl, rights, onChangeUserActive} = props;
    const role = Biscuit.get('user.role');
    return (
        <>
            <div className={"inb-c-item inb-c-item--order row" + (user.active === true ? ' not-marked' : ' red-marked')} key={index}>
                <div className="large-2 medium-8 small-8 column show-label" title={t('kunden_nbr',null,'capital')} >
                    <span>{user.customer_nbr}</span>
                </div>
                <div className="large-2 medium-8 small-8 column show-label" title={t('name',null,'capital')} >
                    <span>{user.first_name + ' ' + user.last_name}</span>
                </div>
                <div className="large-2 medium-8 small-8 column show-label" title={t('username',null,'capital')} >
                    <span>{user.username}</span>
                </div>
                <div className="large-2 medium-8 small-8 column inb-user--email show-label" title={t('email',null,'capital')} >
                    {user.email}
                </div>
                <div className="large-1 medium-8 small-8 column show-label" title={t('role',null,'capital')} >
                    {t('role_' + user.role)}
                </div>
                <div className="large-1 medium-8 small-8 column show-label" title={t('created',null,'capital')} data-label="Erstellt am: ">
                    <span>{moment(user.created).format('DD.MM.YYYY')}</span>
                </div>
                <div className="show-for-large column large-2">
                    <div className="large-12 medium-offset-0 medium-8 column item-button-group">
                        <div className="button-container">
                            { rbac.hasPermission('editUser') && (rights[role] >= rights[user.role]) &&
                                <a
                                    href={"/users/"+user.id+'?path=/users/staff' + currentUrl.search.replace('?','&')}
                                    title={t('edit')}
                                    data-inb-action-link="edit">
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-edit"></div>
                                    </button>
                                </a>
                            }
                        </div>
                        <div className="button-container">
                            { rbac.hasPermission('delete') && (rights[role] >= rights[user.role]) && <>
                                { deleteUserPending !== index ? <>
                                    <a
                                        href="#"
                                        className="inb-reservation__pdf2"
                                        title={t('delete')}>
                                        <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => onDeleteUser(user,index)}>
                                            <div className="inb-fi-remove"></div>
                                        </button>
                                    </a>
                                </>: <>
                                    <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                                </>}</>
                            }
                        </div>
                        <div className="button-container" >
                            <a
                                href={"/usersExtension/mailSettings?id=" + user.id + "&path=/users/staff" + currentUrl.search.replace('?','&')}
                                title={t('email_settings')}>
                                <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-mail"></div>
                                </button>
                            </a>
                        </div>
                        { user.active &&
                            <div className="button-container">
                                <a
                                    href={"/orders/add?user_id=" + user.id + "&skipFilter=1"}
                                    title={t('add_${a}',{a:t('order')})}>
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-page-add"></div>
                                    </button>
                                </a>
                            </div>
                        }
                        <div className="button-container">
                            <a
                                href={"/reservations/reservationsList?user_id=" + user.id + "&fullname=" + user.first_name + " " + user.last_name}
                                title={t('orders',null,'capital')}>
                                <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-page"></div>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="show-for-medium-only">
                    <div className="large-1 medium-offset-0 medium-8 column item-button-group" style={{marginRight: "5%", float: "left", display: "block"}}>
                        <div className="button-container">
                            { rbac.hasPermission('editUser') && (rights[role] >= rights[user.role]) &&
                                <a
                                    href={"/users/"+user.id+'?path=/users/staff' + currentUrl.search.replace('?','&')}
                                    title={t('edit')}
                                    data-inb-action-link="edit">
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-edit"></div>
                                    </button>
                                </a>
                            }
                        </div>
                        <div className="button-container">
                            { rbac.hasPermission('delete') && (rights[role] >= rights[user.role]) && <>
                                { deleteUserPending !== index ? <>
                                    <a
                                        href="#"
                                        className="inb-reservation__pdf2"
                                        title={t('delete')}>
                                        <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => onDeleteUser(user,index)}>
                                            <div className="inb-fi-remove"></div>
                                        </button>
                                    </a>
                                </>: <>
                                    <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                                </>}</>
                            }
                        </div>

                    </div>

                    <div className="large-1 medium-offset-0 medium-8 column item-button-group btn-grp-2" style={{marginRight: "5%", float: "left", display: "block"}}>
                        <div className="button-container" >
                            <a
                                href={"/usersExtension/mailSettings?id=" + user.id + "&path=/users/staff" + currentUrl.search.replace('?','&')}
                                title={t('email_settings')}>
                                <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-mail"></div>
                                </button>
                            </a>
                        </div>
                        { user.active &&
                            <div className="button-container">
                                <a
                                    href={"/orders/add?user_id=" + user.id + "&skipFilter=1"}
                                    title={t('add_${a}',{a:t('order')})}>
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-page-add"></div>
                                    </button>
                                </a>
                            </div>
                        }
                        <div className="button-container">
                            <a
                                href={"/reservations/reservationsList?user_id=" + user.id + "&fullname=" + user.first_name + " " + user.last_name}
                                title={t('orders',null,'capital')}>
                                <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-page"></div>
                                </button>
                            </a>
                        </div>
                    </div>

                </div>


                <div className="show-for-small-only">
                    <div className="large-1 medium-offset-0 medium-8 column item-button-group" style={{marginRight: "5%", float: "left", display: "block"}}>
                        <div className="button-container">
                            { rbac.hasPermission('editUser') && (rights[role] >= rights[user.role]) &&
                                <a
                                    href={"/users/"+user.id+'?path=/users/staff' + currentUrl.search.replace('?','&')}
                                    title={t('edit')}
                                    data-inb-action-link="edit">
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-edit"></div>
                                    </button>
                                </a>
                            }
                        </div>
                        <div className="button-container">
                            { rbac.hasPermission('delete') && (rights[role] >= rights[user.role]) && <>
                                { deleteUserPending !== index ? <>
                                    <a
                                        href="#"
                                        className="inb-reservation__pdf2"
                                        title={t('delete')}>
                                        <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => onDeleteUser(user,index)}>
                                            <div className="inb-fi-remove"></div>
                                        </button>
                                    </a>
                                </>: <>
                                    <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                                </>}</>
                            }
                        </div>
                    </div>

                    <div className="large-1 medium-offset-0 medium-8 column item-button-group btn-grp-2" style={{marginRight: "5%", float: "left", display: "block", marginTop: "12%"}}>
                        <div className="button-container" >
                            <a
                                href={"/usersExtension/mailSettings?id=" + user.id + "&path=/users/staff" + currentUrl.search.replace('?','&')}
                                title={t('email_settings')}>
                                <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-mail"></div>
                                </button>
                            </a>
                        </div>
                        { user.active &&
                            <div className="button-container">
                                <a
                                    href={"/orders/add?user_id=" + user.id + "&skipFilter=1"}
                                    title={t('add_${a}',{a:t('order')})}>
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-page-add"></div>
                                    </button>
                                </a>
                            </div>
                        }
                        <div className="button-container">
                            <a
                                href={"/reservations/reservationsList?user_id=" + user.id + "&fullname=" + user.first_name + " " + user.last_name}
                                title={t('orders',null,'capital')}>
                                <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-page"></div>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StaffWebView;